import "./Overlay.css";

import {
  FRONTEND_ASSETS_BASE_URL,
  GA_ACTION,
  GA_CATEGORIES,
  GA_LABEL,
  GA_PAGE,
  PAGE_URLS,
} from "../../utils/constants";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import WishlinkButton from "../../WishlinkComponents/WishlinkButton";
import WishlinkTypography from "../../WishlinkComponents/WishlinkTypography";
import { tokens } from "../../theme";
import { triggerGa } from "../../utils/gaUtils";
import { useTheme } from "@mui/material";
import { auth } from "../../utils/firebase";

function BrandPageOverlay() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const location = useLocation();
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [hasValidToken, setHasValidToken] = useState(false);

  useEffect(() => {
    const timerId = setTimeout(() => {
      let loginOverlayCount =
        parseInt(localStorage.getItem("loginOverlayCount")) || 0;
      if (loginOverlayCount < 3) setIsOverlayOpen(true);
      localStorage.setItem("loginOverlayCount", loginOverlayCount + 1);
    }, 5000);
    return () => {
      clearTimeout(timerId);
    };
  }, []);

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        // Check if user is authenticated with Firebase
        if (auth?.currentUser) {
          const firebaseToken = await auth.currentUser.getIdToken();
          if (firebaseToken) {
            setHasValidToken(true);
            return;
          }
        }

        // Check only for admin token in localStorage
        if (localStorage.adminToken) {
          setHasValidToken(true);
          return;
        }

        setHasValidToken(false);
      } catch (error) {
        console.error("Error checking auth status:", error);
        setHasValidToken(false);
      }
    };

    checkAuthStatus();
  }, []);

  const showBrandOverlay =
    location.pathname.includes("brands") && !hasValidToken;
  const onClickCloseOverlay = () => {
    setIsOverlayOpen(false);
    triggerGa({
      category: GA_CATEGORIES.USER_INTERACTION,
      action: GA_ACTION.ICON_CLICK,
      label: GA_LABEL.LOGIN_CLOSE,
      page: GA_PAGE.PUBLIC_BRANDS,
      screenName: location.pathname,
    });
  };

  const onClickLoginBtn = () => {
    navigate(PAGE_URLS.FIREBASELOGIN + `?utm_source=publicbrands`);
    triggerGa({
      category: GA_CATEGORIES.NAVIGATION,
      action: GA_ACTION.BUTTON_CLICK,
      label: GA_LABEL.LOGIN,
      page: GA_PAGE.PUBLIC_BRANDS,
      screenName: location.pathname,
    });
  };

  if (!showBrandOverlay) {
    return <></>;
  }
  return (
    <div className="main-content">
      {isOverlayOpen && (
        <div className="overlay-content">
          <div className="close-btn" onClick={onClickCloseOverlay}>
            &times;
          </div>
          <WishlinkButton
            background={colors.grey[0]}
            style={{
              ":hover": {
                bgcolor: colors.grey[0],
              },
              ":disabled": {
                bgcolor: colors.grey[800],
              },
            }}
            borderRadius="3rem"
            width="70%"
            height="2.3rem"
            className="pt-3 mt-3 mb-3"
            onClick={() => onClickLoginBtn()}
          >
            <WishlinkTypography
              fontSize="0.75rem"
              color="rgba(227, 129, 37, 0.6)"
            >
              wishlink.com/
            </WishlinkTypography>
            <WishlinkTypography
              color="rgba(227, 129, 37, 0.6)"
              fontSize="0.75rem"
              pr="3rem"
            >
              username
            </WishlinkTypography>
            <div className="rectangle-wrapper ml-2">
              <img
                style={{ width: "1.5rem" }}
                alt="Rectangle"
                src={FRONTEND_ASSETS_BASE_URL + "creator-signup-animation.gif"}
              />
            </div>
          </WishlinkButton>
          <WishlinkTypography
            color={colors.grey[0]}
            fontSize="0.875rem"
            className="mt-2"
          >
            Are you a creator?
          </WishlinkTypography>
          <WishlinkTypography
            color={colors.grey[0]}
            fontSize="0.75rem"
            className="mt-2"
          >
            Monitize your content with Wishlink
          </WishlinkTypography>
        </div>
      )}
    </div>
  );
}

export default BrandPageOverlay;
